import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axiosConfig';
import GroundResponseDetail from './GroundResponseDetail';

/**
 * /seismic/detail/:boreholeId 라우트 래퍼.
 *
 * 내진설계 지원 흐름을 거치지 않고 특정 시추공의 지반응답해석을 바로 열 수 있게 한다.
 * (시추공 상세 화면·결과 목록에서 링크로 들어온다)
 */
const GroundResponseDetailPage = () => {
  const { boreholeId } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');

  useEffect(() => {
    let alive = true;
    axios
      .get('/boreholes/')
      .then((res) => {
        if (!alive) return;
        const found = (res.data?.data || []).find(
          (b) => String(b.id) === String(boreholeId)
        );
        if (found) setName(found.name);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [boreholeId]);

  return (
    <div className="p-6 bg-secondary-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <GroundResponseDetail
          boreholeId={Number(boreholeId)}
          boreholeName={name}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default GroundResponseDetailPage;
